import { NetworkActionPrefix, ActionType, RequestStatus } from '../utils/constants';
import defaults from '../api/defaults';
import { deepAssign } from '../utils';
import {
    pipeReducers, combineReducers, assignmentReducer,
    networkEntityAddReducer, networkEntityEditReducer, networkEntityLoadReducer, networkEntityDeleteReducer, networkObjectLoadReducer
} from '../utils/reducerFactory';

const DEFAULT_STATE = {
    list: defaults.NetworkArrayOf(defaults.MarketRssWatchSetting),
    editable: defaults.MarketRSSWatchSettingReport,
    rssPreview: deepAssign(defaults.NetworkArray, { Custom: { status: 'initial' } }), //TODO: refactor default status to standard constant 'initial'
    modalWindows: {
        stack: [],
        lastId: 0
    }
};

function getDataArrayIndex(list, ID) {
    if (ID !== undefined && ID !== null) {
        return list.getIndexByID(ID) !== -1 ? list.getIndexByID(ID) : list.length;
    }
    return undefined;
}

const rssSettings = pipeReducers(
    combineReducers({
        list: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_MARKET_RSS_WATCH_SETTINGS_LIST_PREFIX, DEFAULT_STATE.list),
            combineReducers({
                Data: combineReducers({
                    '@dataArrayIndex': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_MARKET_RSS_WATCH_SETTING_PREFIX, defaults.MarketRSSWatchSettingReport, (state, action) => action.marketRssSetting),
                        function (state = defaults.MarketRSSWatchSettingReport, action) {
                            switch (action.type) {
                                case ActionType.SAVE_MARKET_RSS_SETTING:
                                    return deepAssign(state, { ID: action.ID });
                                case ActionType.ADD_MARKET_RSS_WATCH_SETTING_SUCCESS:
                                    return deepAssign(state, { ID: +action.response.ID });
                                default:
                                    return state;
                            }
                        },
                        networkEntityEditReducer(NetworkActionPrefix.EDIT_MARKET_RSS_WATCH_SETTING_PREFIX, defaults.MarketRSSWatchSettingReport, (state, action) => action.marketRssSetting),
                        networkEntityLoadReducer(NetworkActionPrefix.UPDATE_RSS_FEED_ENTRIES_AND_LOAD_MARKET_RSS_WATCH_SETTING_REPORT_PREFIX, defaults.MarketRSSWatchSettingReport),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_MARKET_RSS_WATCH_SETTING_PREFIX),
                    )
                }, {
                        dataArrayIndex: (state, action) =>
                            action.type !== ActionType.EDIT_MARKET_RSS_WATCH_SETTING /*&& action.type !== ActionType.SAVE_MARKET_RSS_WATCH_SETTING*/ ? getDataArrayIndex(state, action.ID) : undefined
                    })
            })
        ),
        editable: pipeReducers(
            state => state || DEFAULT_STATE.editable,
            combineReducers({
                Name: assignmentReducer(ActionType.SET_MARKET_RSS_SETTINGS_NAME, '', 'name'),
                TargetURL: assignmentReducer(ActionType.SET_MARKET_RSS_SETTINGS_TARGET_URL, '', 'targetURL'),
                PESTELAreaID: assignmentReducer(ActionType.SET_MARKET_RSS_SETTINGS_PESTEL_AREA, null, 'pestelAreaID'),
                SWOTTopicID: function (state, action) {
                    switch (action.type) {
                        case ActionType.SET_MARKET_RSS_SETTINGS_SWOT_TOPIC:
                            return action.swotTopicID;
                        default:
                            return state;
                    }
                },
                PersonalTopicID: function (state, action) {
                    switch (action.type) {
                        case ActionType.SET_MARKET_RSS_SETTINGS_PERSONAL_TOPIC:
                            return action.personalTopicID;
                        default:
                            return state;
                    }
                },
                TrendTopicID: function (state, action) {
                    switch (action.type) {
                        case ActionType.SET_MARKET_RSS_SETTINGS_TREND_TOPIC:
                            return action.trendTopicID;
                        default:
                            return state;
                    }
                },
                StakeholderID: assignmentReducer(ActionType.SET_MARKET_RSS_SETTINGS_STAKEHOLDER_ID, null, 'stakeholderID'),
                CompanyLegalEntityID: assignmentReducer(ActionType.SET_MARKET_RSS_SETTINGS_COMPANY_LEGAL_ENTITY_ID, null, 'companyLegalEntityID'),
                CompanyFunctionID: assignmentReducer(ActionType.SET_MARKET_RSS_SETTINGS_COMPANY_FUNCTION_ID, null, 'companyFunctionID'),
                ModeratorID: assignmentReducer(ActionType.SET_MARKET_RSS_SETTINGS_MODERATOR, '', 'moderatorID')
            })
        ),
        rssPreview: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.MARKET_RSS_WATCH_SETTING_LOAD_PREVIEW_PREFIX, DEFAULT_STATE.rssPreview),
            (state, action) => {
                if (action.type === ActionType.SET_MARKET_RSS_SETTINGS_TARGET_URL) {
                    return deepAssign({}, DEFAULT_STATE.rssPreview);
                }
                return state;
            }
        ),
        modalWindows: (state = DEFAULT_STATE.modalWindows, action) => {
            switch (action.type) {
                case ActionType.SHOW_MODAL_WINDOW_ON_RSS_SETTINGS_PAGE: {
                    let newStack = state.stack.slice();
                    let newId = state.lastId + 1;
                    let newModal = {
                        renderMethod: action.renderMethod,
                        renderParams: Object.assign(action.renderParams, { modalWindowId: newId }),
                        id: newId
                    };
                    newStack.unshift(newModal);

                    return Object.assign({}, state, {
                        stack: newStack,
                        lastId: newId
                    });
                }
                case ActionType.CLOSE_MODAL_WINDOW_ON_RSS_SETTINGS_PAGE: {
                    let newStack = state.stack.slice();
                    let targetModalIdx = newStack.findIndex(window => window.id === action.modalId);

                    newStack.splice(targetModalIdx, 1);

                    return Object.assign({}, state, {
                        stack: newStack
                    });
                }
                case ActionType.CLOSE_ALL_MODAL_WINDOWS_ON_RSS_SETTINGS_PAGE:
                    return Object.assign({}, state, {
                        stack: DEFAULT_STATE.modalWindows.stack
                    });
                default:
                    return state;
            }
        }
    }),
    function (state = DEFAULT_STATE, action) {
        switch (action.type) {
            case ActionType.MARKET_RSS_SETTING_OPEN_FOR_EDIT:
                let result = deepAssign(state, {
                    editable: !isNaN(action.ID) ?
                        state.list.Data.getByID(action.ID) :
                        deepAssign(defaults.MarketRSSWatchSettingReport, { Custom: { status: RequestStatus.SUCCEEDED } })
                });
                return deepAssign(result, {
                    rssPreview: DEFAULT_STATE.rssPreview
                });

            case ActionType.SAVE_MARKET_RSS_SETTING:
                return deepAssign(state, {
                    list: {
                        Data: {
                            [getDataArrayIndex(state.list.Data, action.ID)]: deepAssign({}, state.editable)
                        }
                    }
                });

            case ActionType.VALIDATE_EDITABLE_RSS_SETTING_INPUTS:
                return deepAssign(state, {
                    editable: deepAssign(state.editable, { Custom: { validation: action.validationResult } })
                });

            default:
                return state;
        }
    },
    function (state, action) {
        switch (action.type) {
            case ActionType.DELETE_STAKEHOLDER_SUCCESS:
            case ActionType.DELETE_SWOT_SESSION_SUCCESS:
            case ActionType.DELETE_SWOT_TOPIC_SUCCESS:
            case ActionType.DELETE_TREND_TOPIC_SUCCESS:
                // TODO make it more targeted, not all parts require update
                return rssSettings(undefined, { type: '@@redux/INIT' });
            default:
                return state;
        }
    }
);

export default rssSettings;